import type { OrderDetailResponseDto } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { FormAutocomplete } from "Shared/Components/Form/CustomFormComponent/FormAutocomplete";
import { useManagerOptions } from "Shared/Hooks/useManagerOptions";
import { Box, Grid2, Stack, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";

type AssignUserProps = {
	order: OrderDetailResponseDto;
};

const formResource = Resources.base.order.editForm;

export const AssignUserForm = ({ order }: AssignUserProps) => {
	const { t } = useResource();

	const {
		control,
		formState: { errors },
		setValue,
	} = useFormContext();

	const handleResetUser = () => {
		setValue("userId", null, { shouldDirty: true });
	};

	const userOption = useManagerOptions(order.market);

	return (
		<Stack alignItems="start">
			<Box width="100%">
				<Grid2 container spacing={2}>
					<Grid2 size={{ xs: 12 }}>
						<FormAutocomplete
							id="user-id"
							name="userId"
							control={control}
							errors={errors}
							options={userOption}
							fullWidth
							numeric
							sxLabel={{ marginTop: 0 }}
							groupBy={(option) => option.group as string}
						/>
					</Grid2>
				</Grid2>

				<Stack
					flexDirection="row"
					justifyContent="space-between"
					width="100%"
					mt={1}
				>
					<Box onClick={handleResetUser} sx={{ cursor: "pointer" }}>
						<Typography variant="caption" color="primary">
							{t(formResource.reset)}
						</Typography>
					</Box>
				</Stack>
			</Box>
		</Stack>
	);
};
